/*
 * Simplebox
 *
 * Basic lightbox implementation
 */

ckdc.ready(function ($) {
  // main ckdc object required
  if (typeof ckdc == 'undefined') {
    return;
  }

  // lightbox already defined?
  if (typeof ckdc.simplebox !== 'undefined') {
    return;
  }


  /*
   * Private variables;
   */

  var defaultOptions = {
    // todo, for live search
    // requireFocus : false,
    closeButton: true,
    requireButtonClose: false,
    centerVertical: false,
    centerHorizontal: false,
    wrapperClasses: '',
    closeClasses: '',
    beforeContent: '',
    callbackClose: function () {
    }
  };

  var options = {};

  var wrapper = null;
  var contentWrapper = null;

  // todo: for live search and requireFocus option
  // var closeTimeout = 0;


  /*
   * Private functions
   */

  function stopFlexslider() {
    var flexslider = $('.flexslider');
    if (flexslider.length && typeof flexslider.flexslider == 'function') {
      flexslider.flexslider('stop');
    }
  }

  function startFlexslider() {
    var flexslider = $('.flexslider');
    if (flexslider.length && typeof flexslider.flexslider == 'function') {
      flexslider.flexslider('play');
    }
  }

  // setup simplebox DOM & state
  function setup(overrideOptions) {
    options = Object.assign({}, defaultOptions); // Clone default options.
    if (typeof overrideOptions !== 'undefined') {
      // loop over our options array, and check if it should be overridden
      $.each(options, function (i, v) {
        if (overrideOptions.hasOwnProperty(i)) {
          options[i] = overrideOptions[i];
        }
      });
    }

    setupWrapper();
  }

  // setup wrapper
  function setupWrapper() {
    if (wrapper != null) {
      return;
    }

    // exist already?
    wrapper = $('.simplebox-wrapper');
    if (!wrapper.length) {
      var anchor = $('.simplebox-anchor');
      var wrapperClasses = ['simplebox-wrapper'];
      if (anchor.length) {
        wrapperClasses.push('simplebox-anchor');
      } else {
        wrapperClasses.push('simplebox-fixed');
      }

      if (options.wrapperClasses) {
        wrapperClasses.push(options.wrapperClasses);
      }

      var contentClasses = ['simplebox-content'];
      if (options.centerVertical) {
        contentClasses.push('ac');
      }
      if (options.centerHorizontal) {
        contentClasses.push('center-vertical');
      }

      wrapper = $('<div class="' + wrapperClasses.join(' ') + '"><div class="simplebox">'
        + ( options.beforeContent && options.beforeContent.length ? options.beforeContent : '' )
        + '<div class="simplebox-content-wrapper">'
        + (options.closeButton ? '<div class="simplebox-close"><i class="fa fa-times" aria-hidden="true"></i></div>' : '')
        + '<div class="' + contentClasses.join(' ') + '">'
        + '</div></div></div></div>');

      // if simplebox-anchor exists, add inside
      if (anchor.length >= 1) {
        wrapper.appendTo(anchor);
      } else {
        // otherwise add to end of body
        wrapper.appendTo('body');
      }

      if (options.closeClasses) {
        wrapper.find('.simplebox-close').addClass(options.closeClasses);
      }
    }

    contentWrapper = wrapper.find('.simplebox-content');

    if (options.closeButton) {
      wrapper.on('click', '.simplebox-close', closeEvent);
    }

    if ( ! options.requireButtonClose ) {
      ckdc.body.on('click', '#site-wrapper', closeEvent);
    }
  }

  // remove simplebox DOM, clear state
  function remove() {
    if (wrapper != null) {
      wrapper.remove();
      wrapper = null;
      contentWrapper = null;
      options.beforeContent = '';
      ckdc.body.off('click', '#site-wrapper', closeEvent);
    }
  }

  // set simplebox content
  function setContent(content) {
    contentWrapper.html(content);
  }

  // add ajax working content, if needed
  function addAjaxWorkingContent() {
    if (!wrapper.find('simplebox-ajax-wrapper').length) {
      wrapper.append('<div class="simplebox-ajax-wrapper"><i class="fa fa-spinner fa-pulse"></i></div>');
    }
  }

  // remove ajax working content
  function removeAjaxWorkingContent() {
    wrapper.find('.simplebox-ajax-wrapper').remove();
  }

  // handle event to close simplebox
  function closeEvent(event) {
    if (!wrapper.hasClass('ajax-working')) {
      ckdc.simplebox.close();
    }

    event.preventDefault();
    return false;
  }

  /*
   * Public object, insert into our global object
   */

  ckdc.simplebox = {
    // init simplebox options
    init: function (overrideOptions) {
      setup(overrideOptions);
    },

    // setup simplebox listener
    setupOnce: function () {
      // Start ajax working on any clicks on class "ckdc-start-working"
      ckdc.body.on('click.simplebox', '.ckdc-start-working', function (e) {
        ckdc.simplebox.startAjaxWorking();
        return true;
      });
    },

    // open simplebox, optionally with (new) content and options
    open: function (content, overrideOptions) {
      if ( wrapper && wrapper.hasClass('active') ) {
        return;
      }

      setup(overrideOptions); // make sure DOM & state is setup

      if (typeof content !== 'undefined') {
        setContent(content);
      }

      if (!document.body.classList.contains('simplebox-active')) {
        localStorage.cachedScrollPos = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      }

      wrapper.addClass('active');
      ckdc.body.addClass('simplebox-active');
	  ckdc.simplebox.setupContent();
    },

    // call setupContent functions for simplebox content
    setupContent: function () {
      if (contentWrapper != null) {
        ckdc.setup.setupContent(contentWrapper);
      }
    },

    // get content wrapper
    getContentWrapper: function () {
      return contentWrapper;
    },

    // close simplebox (including removing content)
    close: function () {
      ckdc.simplebox.stopAjaxWorking();
      ckdc.body.removeClass('simplebox-active');
      wrapper.removeClass('active');
      remove();

      // Restore scroll position
      if (!document.body.classList.contains('simplebox-active')) {
        window.scrollTo(0, localStorage.cachedScrollPos);
      }

      options.callbackClose();

      startFlexslider();
    },

    startAjaxWorking: function () {
      setup(); // make sure DOM & state is setup

      addAjaxWorkingContent();
      wrapper.addClass('ajax-working');
      ckdc.body.addClass('simplebox-ajax-working');
    },

    stopAjaxWorking: function () {
      removeAjaxWorkingContent();
      wrapper.removeClass('ajax-working');
      ckdc.body.removeClass('simplebox-ajax-working');
    },
  };

  ckdc.setup.addSetupOnce('simplebox', ckdc.simplebox.setupOnce);
});
